import capitalize from "lodash/capitalize";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useHomepageContext } from "../HomepageContext";
import { UpcomingEvent } from "./UpcomingEvent";

export const UpcomingEventsSection = () => {
  const { upcomingEvents } = useHomepageContext();

  if (upcomingEvents.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames(
        "sidebar__block sidebar__right upcoming-events !bg-primary !border-primary block !rounded-2xl",
      )}
    >
      <Typography.LabelMd weight="semibold">
        {capitalize(t("upcoming_events"))}
      </Typography.LabelMd>
      <ul className="mt-4 flex list-none flex-col gap-5">
        {upcomingEvents.map(
          ({
            id: eventId,
            name: eventName,
            start_date: startDate,
            show_path: showPath,
            starts_at: startsAt,
            ends_at: endsAt,
            time_zone_abbreviations: timeZoneAbbreviation,
            time_zone: timeZone,
          }) => (
            <UpcomingEvent
              key={eventId}
              eventName={eventName}
              startDate={startDate}
              showPath={showPath}
              startsAt={startsAt}
              endsAt={endsAt}
              timeZoneAbbreviation={timeZoneAbbreviation}
              timeZone={timeZone}
            />
          ),
        )}
      </ul>
    </div>
  );
};
